import {defineMessages} from 'react-intl';

export default defineMessages({
    title: {
        id: 'notFoundPage.title'
    }
});
